export default {"src":"/_next/static/media/playIcon.2f29c956.svg","height":42,"width":43,"blurWidth":0,"blurHeight":0};